/**
 * Helper class to build action permissions object
 */
export default class PermsItem {
  /**
   * @param {boolean | Array} perms boolean or user groups
   */
  constructor(perms) {
    const isAll = typeof perms === 'boolean';

    if (isAll) {
      this.all = isAll && perms;
      this.allowed = [];
    } else {
      this.all = false;
      this.allowed = perms;
    }

    this.rules = [];
  }

  /**
   * Adds a rule to the custom rules array
   * @param {function} func custom rule function
   */
  addRule = (func) => {
    this.rules.push(func);
  };
}
